(function ($, njm) {
    'use strict';

    njm.views.articlesHeroMobile = Backbone.View.extend({

        events: {
			
        },

        // supported medias for this view
        medias: ['mobile'],

        /**
         * Initialize
         */
        initialize: function () {
            this.template = $('#comp-articles-hero-mobile').html();

            // Render
            this.render();
			
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
        }
		
    });
})(jQuery, njm);
